import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import FormatItalic from "@mui/icons-material/FormatItalic";
import { IconButton, Tooltip } from "@mui/material";
import { FORMAT_TEXT_COMMAND } from "lexical";
import { floatingToolbarStyles } from "./floating-toolbar-styles";

import type { ToolbarProps } from "./props";
import type { FC } from "react";

export const ItalicButton: FC<ToolbarProps & { active: boolean }> = ({
  disabled,
  active,
  mode,
}) => {
  const [editor] = useLexicalComposerContext();

  return (
    <Tooltip title="Italic">
      <IconButton
        data-analytics-id={`lexical-${mode}-italic`}
        disabled={disabled}
        data-testid={`${mode}-button-italic`}
        data-active={active}
        aria-label="Italic"
        aria-pressed={active}
        tabIndex={-1}
        sx={{
          ...floatingToolbarStyles[mode].button,
          backgroundColor: active ? "background.active" : "background.neutral",
        }}
        onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "italic")}
      >
        <FormatItalic sx={floatingToolbarStyles[mode].formatIcon} />
      </IconButton>
    </Tooltip>
  );
};
